import React from 'react';
import { useTranslation } from 'react-i18next';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import styles from '../ReservationCheck/OccasionSelector/occasionSelector.module.css';

const LeadReason = ({ handleSelectButton, selectedButton }) => {
  const { t } = useTranslation();
  const types = [
    {
      value: 'Inversión',
      label: t('Inversión'),
    },
    {
      value: 'Residencia principal',
      label: t('Residencia principal'),
    },
    {
      value: 'Residencia secundaria',
      label: t('Residencia secundaria'),
    },
    {
      value: 'Uso mixto',
      label: t('Uso mixto'),
    },
    {
      value: 'Otros',
      label: t('Otros'),
    },
  ];

  return (
    <>
      <div className='fw-semibold text-primary font-tiny'>{t('Motivo de la compra')}</div>
      <Swiper spaceBetween={10} slidesPerView={'auto'} className={`${styles.swiperContainer} mt-3`}>
        {types.map((p) => (
          <SwiperSlide key={p.value}>
            <button
              onClick={() => handleSelectButton(p.value)}
              className={`font-small fade-up ${styles.occasionButton} ${
                selectedButton === p.value ? styles.selected : null
              }`}
              type='button'
            >
              {p.label}
            </button>
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
};

export default LeadReason;
